/**
 * Created by csaba.adam on 2017. 07. 18..
 */
import $ from 'jquery';

const COMISSION_TYPES = {
	TO_RENT: 'toRent',
	TO_SELL: 'toSell'
};

export const RealEstateRelatedComponent = {
	bindings: {
		relatedProperties: '<',
		project: '<',
		comissionType: '<'
	},
	templateUrl: 'real-estate-related.html',
	controller: class RealEstateRelatedComponent {
		constructor($timeout, $rootScope, favouriteService) {
			'ngInject';
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.favouriteService = favouriteService;
			this.COMISSION_TYPES = COMISSION_TYPES;
		}

		$onInit() {
			this.isLoggedIn = this.$rootScope.isLoggedIn;
			this.initCarouselEvents();
		}

		$onChanges(changes) {
			if (changes.relatedProperties) {
				if (this.relatedProperties) {
					this.related = angular.copy(this.relatedProperties);
				}
			}
			if (changes.project) {
				if (this.project) {
					this.projectInfo = angular.copy(this.project);
					this.isProject = true;
				} else {
					this.isProject = false;
				}
			}
			if (changes.comissionType) {
				if (this.comissionType) {
					this.typeOfCommission = angular.copy(this.comissionType);
				}
			}
		}

		setLiked(item) {
			this.item = item;
			this.favouriteService.setFavourite(this.item.comissionId).then(() => {
				this.item.liked = !this.item.liked;
			}).catch((error) => {
				console.log(error);
			});
		}

		navigateToProperty($event, item) {
			if (angular.element($event.target).is(':button')) {
				$event.preventDefault();
			} else {
				window.location.href = item.url;
			}
		}

		initCarouselEvents() {
			let vm = this;
			if (this.related && angular.element('.related-slick_0').length) {
				this.related.forEach((prop, index) => {
					vm.lazyBgImg(true, 0, index);
					angular.element('.related-slick_' + index).on('beforeChange', (event, slick, slide, nextSlide) => {
						if (slide != nextSlide) {
							vm.lazyBgImg(angular.element(slick.$slides.get(nextSlide)), nextSlide, index);
						}
					});
					angular.element('.related-slick_' + index).on('init', (event, slick) => {
						vm.lazyBgImg(angular.element(slick.$slides.get(0)), 0, index);
					});
				});
			} else {
				vm.$timeout(() => {
					vm.initCarouselEvents();
				}, 300);
			}
		}

		lazyBgImg(element, nextSlide, relIndex) {
			let vm = this;
			if (element) {
				let lazyBgImgs = angular.element('.lazy-bg-related-img_' + relIndex + '_' + nextSlide);
				$.each(lazyBgImgs, function (index, el) {
					$(el).css('background-image', 'url(' + vm.related[relIndex].images[nextSlide].url + ')');
				});
			}
		}
	}
};
